<template>
  <div class="addclient row justify-content-md-center">
    <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <div><span class="badge" :class="$route.meta.step === 1 ? 'badge-primary':'badge-secondary'">1.</span></div>
          <div><span class="badge" :class="$route.meta.step === 2 ? 'badge-primary':'badge-secondary'">2.</span></div>
          <div><span class="badge" :class="$route.meta.step === 3 ? 'badge-primary':'badge-secondary'">3.</span></div>
          <div><span class="badge" :class="$route.meta.step === 4 ? 'badge-primary':'badge-secondary'">4.</span></div>
          <div><span class="badge" :class="$route.meta.step === 5 ? 'badge-primary':'badge-secondary'">5.</span></div>
        </div>
        <div class="card-header text-center" data-testid="registration-step-label">
          {{ $route.meta.label }}
        </div>
        <div>

        </div>
        <router-view @completed-step="stepDone" @client-id="setClientId"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        completedStep: null,
        clientId: null,
        clientIdFromFirstStep: null
      }
    },
    methods: {
      setClientId: function (value) {
        this.clientIdFromFirstStep = value
      },
      stepDone: function (value) {
        this.completedStep = value
        if (value === 1) {
          this.clientId = this.clientIdFromFirstStep
          this.$router.push({name: 'RegistrationClientSelectInsurance', params: { clientid: this.clientId }})
        } else if (value === 2) {
          this.clientId = this.$route.params.clientid
          this.$router.push({name: 'RegistrationClientSelectEmail', params: { clientid: this.clientId }})
        } else if (value === 3) {
          this.clientId = this.$route.params.clientid
          this.$router.push({name: 'RegistrationClientSelectPhone', params: { clientid: this.clientId }})
        } else if (value === 4) {
          this.clientId = this.$route.params.clientid
          this.$router.push({name: 'RegistrationClientSelectAddress', params: { clientid: this.clientId }})
        }
      }
    },
    beforeMount () {
      // this.getPhoneNumbers()
      // this.getCitizenship()
      // this.getCountries()
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .icon-male {
    color: dodgerblue;
    font-weight: bold;
  }

  .icon-female {
    color: deeppink;
    font-weight: bold;
  }

  .icon-genderless {
    color: #ccc;
    font-weight: bold;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    vertical-align: middle;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/Registration/Registration.vue?642e7aac